import React, { useEffect, useState } from 'react';
import { CloseSmall } from '@icon-park/react';
import { BUSINESS_CONFIG } from '../../../config';

function ShareModal({ isOpen, shareLink, createdId, onClose }) {
  const [qrState, setQrState] = useState('loading');
  const [qrAttempt, setQrAttempt] = useState(0);
  useEffect(() => {
    setQrState('loading');
    setQrAttempt(0);
  }, [isOpen, createdId, shareLink]);
  if (!isOpen) return null;

  const qrSrc = createdId
    ? `/api/foodlabel/labels/${createdId}/qrcode`
    : `https://api.qrserver.com/v1/create-qr-code/?size=${BUSINESS_CONFIG.QRCODE.DISPLAY_SIZE}x${BUSINESS_CONFIG.QRCODE.DISPLAY_SIZE}&ecc=${BUSINESS_CONFIG.QRCODE.ERROR_CORRECTION_LEVEL}&data=${encodeURIComponent(shareLink || '')}`;

  const downloadHref = createdId
    ? `/api/foodlabel/labels/${createdId}/qrcode`
    : `https://api.qrserver.com/v1/create-qr-code/?size=${BUSINESS_CONFIG.QRCODE.DOWNLOAD_SIZE}x${BUSINESS_CONFIG.QRCODE.DOWNLOAD_SIZE}&ecc=${BUSINESS_CONFIG.QRCODE.ERROR_CORRECTION_LEVEL}&data=${encodeURIComponent(shareLink || '')}`;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <CloseSmall theme="outline" size={18} />
        </button>
        <h2 className="modal-title">保存成功</h2>
        <p className="modal-subtitle">标签已保存。未发布的标签需完成审核与发布后，才可供公众扫码查看。</p>

        <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
          <img
            key={`${createdId || shareLink}-${qrAttempt}`}
            src={qrSrc}
            alt="分享二维码"
            width={BUSINESS_CONFIG.QRCODE.DISPLAY_SIZE}
            height={BUSINESS_CONFIG.QRCODE.DISPLAY_SIZE}
            style={{ display: qrState === 'error' ? 'none' : 'block', border: '1px solid #e8eaed', borderRadius: 8, background: '#fff' }}
            onLoad={() => setQrState('ready')}
            onError={() => setQrState('error')}
          />
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {qrState === 'loading' && <p role="status">正在加载二维码…</p>}
            {qrState === 'error' && <>
              <p role="alert">二维码加载失败，标签内容已保存，请重试。</p>
              <button type="button" className="btn-template" onClick={() => { setQrState('loading'); setQrAttempt(value => value + 1); }}>重新加载二维码</button>
            </>}
            {qrState === 'ready' && <a
              className="btn-template"
              href={downloadHref}
              download={`label-${createdId || 'preview'}-qrcode.png`}
            >
              下载二维码
            </a>}
          </div>
        </div>

        <div style={{ marginTop: 20, textAlign: 'right' }}>
          <button className="btn-close" onClick={onClose}>完成</button>
        </div>
      </div>
    </div>
  );
}

export default ShareModal;
